export const LOADING = 'LOADING';
export const CREATE_MENU_RESPONSE = 'CREATE_MENU_RESPONSE';
export const CREATE_CATEGORY_RESPONSE = 'CREATE_CATEGORY_RESPONSE';
export const CREATE_PRODUCT_RESPONSE = 'CREATE_PRODUCT_RESPONSE';
export const CREATE_VARIANT_RESPONSE = 'CREATE_VARIANT_RESPONSE';
export const UPDATE_MENU_RESPONSE = 'UPDATE_MENU_RESPONSE';
export const UPDATE_CATEGORY_RESPONSE = 'UPDATE_CATEGORY_RESPONSE';
export const UPDATE_PRODUCT_RESPONSE = 'UPDATE_PRODUCT_RESPONSE';
export const UPDATE_VARIANT_RESPONSE = 'UPDATE_VARIANT_RESPONSE';
export const DELETE_MENU_RESPONSE = 'DELETE_MENU_RESPONSE';
export const DELETE_CATEGORY_RESPONSE = 'DELETE_CATEGORY_RESPONSE';
export const DELETE_PRODUCT_RESPONSE = 'DELETE_PRODUCT_RESPONSE';
export const DELETE_VARIANT_RESPONSE = 'DELETE_VARIANT_RESPONSE';



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/contexts/constants.js